export default __webpack_public_path__ + "static/media/gallery_02.b9b95cd1.jpg";